export default "__VITE_ASSET__a6e9ecdb__"